import React from "react";
import { Route, useRouteMatch, Switch, Redirect } from "react-router-dom";
import ChecklistList from "./ChecklistList";
import DiscoverabilityPage from "../ActionItems/Discoverability/DiscoverabilityPage";
import ChecklistActionItemsPage from "./ActionItems/ChecklistActionItemsPage";
import { ChecklistWizard } from "./CreateChecklistWizard";
import OnOffSettingsPage from "../Checklists/OnOffSettings/OnOffSettingsPage";
import ChecklistPreviewPage from "../Preview/CheckList/ChecklistPreviewPage";

const ChecklistsPage = () => {
  let { path } = useRouteMatch();
  return (
    <Switch>
      <Route path={`${path}/wizard`} component={ChecklistWizard} />
      <Route path={`${path}/:checklistId/wizard`} component={ChecklistWizard} />
      <Route path={`${path}/:checklistId`} exact>
        <Redirect to={`${path}`} />
      </Route>
      <Route
        path={`${path}/:checklistId/discoverability`}
        component={DiscoverabilityPage}
        exact
      />
      <Route
        path={`${path}/:checklistId/action-items`}
        component={ChecklistActionItemsPage}
        exact
      />
      <Route
        path={`${path}/:checklistId/on-off-settings`}
        component={OnOffSettingsPage}
        exact
      />
      <Route
        path={`${path}/:checklistId/preview`}
        component={ChecklistPreviewPage}
        exact
      />
      <Route default>
        <ChecklistList />
      </Route>
    </Switch>
  );
};

export default ChecklistsPage;
